import React, { useEffect, useContext, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useMask } from "@react-input/mask";

import { Form } from "react-final-form";
import OtpInput from "react-otp-input";
import { Context } from "../../../../_context/Store";
import Validator from "../../../../_helpers/validate.schema";
import {
    UiCol,
    UiSingleRow,
} from "../../../_uiComponents/grid-container/GridContainer";

import {
    UiInput,
    UiInputLink,
    UiCheckboxInput,
} from "../../../_uiComponents/form/UiInput";
import { EyeIcon } from "../../../../styles/img/svg/EyeIcon";
import { UiButton } from "../../../_uiComponents/form/UiButton";
import {
    preRegistrationRequest,
    preRegistrationActivateRequest,
    reSendOtpRequest,
    ajaxError,
} from "../../../../_redux/_actions";

import RulesAndTermsModal from "../RulesAndTermsModal";
import PrivacyPolicyModal from "../PrivacyPolicyModal";
import ValidateRightDark from "../../../../styles/img/svg/ValidateRightDark";
import ValidateRightLight from "../../../../styles/img/svg/ValidateRightLight";
import { getFingerPrint } from "../../../../_helpers/support.services";
import UiMobileInput from "../../../_uiComponents/form/UiMobileInput";
import {
    otpTypeConstants,
    participantUrl,
} from "../../../../_redux/_constants";

const validateSchema = () =>
    yup.object().shape({
        email: yup
            .string()
            .required("Email is required.")
            .email("Email must be a valid email."),
        password: yup
            .string()
            .required("Password is required.")
            .min(8, "New password must be at least 8 characters long.")
            .matches(
                /[^\w\s]/,
                "New password must contain at least one special character.",
            )
            .matches(
                /[A-Z]/,
                "New password must contain at least one uppercase letter.",
            )
            .matches(
                /[a-z]/,
                "New password must contain at least one lowercase letter.",
            )
            .matches(/[0-9]/, "New password must contain at least one number."),

        firstName: yup.string().required("First name is required."),
        lastName: yup.string().required("Last name is required."),
        activationCode: yup.string().required("Activation code is required."),
        otp: yup
            .string()
            .required("Activation code is required.")
            .min(6, "Enter 6 charator otp number"),
        mobileNo: yup.string().required("Mobile number  is required."),

        // confirmPassword: yup
        //     .string()
        //     .required("Confirm password is required.")
        //     .oneOf(
        //         [yup.ref("password"), null],
        //         "Please make sure your passwords match.",
        //     ),

        // .matches(/^\+44\d{9}$/, "Invalid mobile number."),
        terms: yup.bool().required().oneOf([true], "Field must be checked"),
        policy: yup.bool().required().oneOf([true], "Policy must be checked"),
    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function SignUpForm(props) {
    const actionDispatch = useDispatch();
    const navigate = useNavigate();
    const [state, dispatch] = useContext(Context);
    const [newPassword, setNewPassword] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [otpInput, showOtpInput] = useState(true);
    const [policy, setPolicy] = useState(false);
    const [terms, setTerms] = useState(false);

    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get("user_id");
    const activationCode = urlParams.get("activation_code");

    const { userDetails } = useSelector((state) => {
        return {
            userDetails: state.auth.userProfileDetails,
        };
    });

    const submit = async (values) => {
        const browserFingerprint = await getFingerPrint();

        actionDispatch(
            preRegistrationActivateRequest({
                userId,
                firstName: values.firstName,
                lastName: values.lastName,
                password: values.password,
                activationCode: values.activationCode,
                validateOtp: true,
                email: values.email,
                browserFingerprint,
                otp: values.otp,
                phoneNumber: values.mobileNo,
                navigate,
            }),
        );
    };

    useEffect(() => {
        actionDispatch(preRegistrationRequest({ userId, activationCode }));
    }, []);

    // useEffect(() => {
    // if (seconds > 0) {
    //     const timerId = setTimeout(() => {
    //         setSeconds(seconds - 1);
    //     }, 1000);
    //     // Cleanup the timeout on component unmount
    //     return () => clearTimeout(timerId);
    // }
    // }, [seconds]);

    const showTermsModal = () => {
        dispatch({
            type: "LARGE_MODAL",
            payload: {
                show: true,
                title: "Rules & Terms of Use",
                subTitle: "Accept to progress",
                children: <RulesAndTermsModal />,
            },
        });
    };

    const showPrivacyModal = () => {
        dispatch({
            type: "LARGE_MODAL",
            payload: {
                show: true,
                title: "Privacy Policy",
                subTitle: "Accept to progress",
                children: <PrivacyPolicyModal />,
            },
        });
    };

    const verifyMobileNo = async (phoneNumber) => {
        // showOtpInput(true);
        const browserFingerprint = await getFingerPrint();

        actionDispatch(
            reSendOtpRequest({
                userId: userDetails.id,
                otpTypeId: otpTypeConstants.AUTH_TYPE_ADD_ACCOUNT,
                rememberBrowser: false,
                browserFingerprint,
                phoneNumber: phoneNumber,
            }),
        );
    };

    const checkTerms = (e) => {
        if (e.target.checked === true) {
            setTerms(true);
        } else {
            setTerms(false);
        }
    };

    const checkPolice = (e) => {
        if (e.target.checked === true) {
            setPolicy(true);
        } else {
            setPolicy(false);
        }
    };

    const hostname = window.location.hostname;

    return (
        <>
            <Form
                initialValues={{
                    firstName: hostname.includes(
                        participantUrl.RENAULT_REWARDS_URL,
                    )
                        ? ""
                        : userDetails.firstName,
                    lastName: hostname.includes(
                        participantUrl.RENAULT_REWARDS_URL,
                    )
                        ? ""
                        : userDetails.lastName,
                    email: userDetails.email,
                    activationCode,
                    otp: "",
                    password: "",
                    mobileNo: mobileNumber,
                    policy: false,
                    terms: false,
                }}
                onSubmit={submit}
                validate={onValidate}
                mutators={{
                    setFormAttribute: (
                        [fieldName, fieldVal],
                        state,
                        { changeValue },
                    ) => {
                        changeValue(state, fieldName, () => fieldVal);
                    },
                }}
                render={({
                    form,
                    handleSubmit,
                    hasValidationErrors,
                    valid,
                    errors,
                    values,

                    ...rest
                }) => {
                    return (
                        <form onSubmit={validateSchema}>
                            <UiSingleRow>
                                <UiCol lg="6">
                                    <UiInput
                                        value={values.firstName}
                                        label="First Name"
                                        placeholder="First Name"
                                        type="text"
                                        name="firstName"
                                        maxLength={50}
                                        required
                                        // disabled={
                                        //     hostname.includes(
                                        //         participantUrl.RENAULT_REWARDS_URL,
                                        //     )
                                        //         ? false
                                        //         : true
                                        // }
                                    />
                                </UiCol>

                                <UiCol lg="6">
                                    <UiInput
                                        value={values.lastName}
                                        label="Last Name"
                                        placeholder="Last Name"
                                        type="text"
                                        name="lastName"
                                        maxLength={50}
                                        required
                                        // disabled={
                                        //     hostname.includes(
                                        //         participantUrl.RENAULT_REWARDS_URL,
                                        //     )
                                        //         ? false
                                        //         : true
                                        // }
                                    />
                                </UiCol>
                            </UiSingleRow>

                            <UiCol lg="12">
                                <UiInput
                                    value={values.email}
                                    label="Email address"
                                    placeholder="Enter your email"
                                    type="email"
                                    name="email"
                                    maxLength={300}
                                    disabled={true}
                                />
                            </UiCol>
                            <UiCol lg="12">
                                <UiInput
                                    value={values.activationCode}
                                    label="Activation Code (From your company welcome email)"
                                    placeholder="Add activation code"
                                    type="text"
                                    inputHideIcon={<EyeIcon />}
                                    name="activationCode"
                                    maxLength={300}
                                    disabled={true}
                                />
                            </UiCol>

                            <UiCol lg="12">
                                <UiInput
                                    value={values.password}
                                    label="Password"
                                    placeholder="Password"
                                    type="password"
                                    inputhideicon={<EyeIcon />}
                                    name="password"
                                    maxLength={100}
                                />

                                <div className="sb-password-restrictions">
                                    <ul>
                                        <li>
                                            {values.password?.length >= 8 ? (
                                                <ValidateRightDark />
                                            ) : (
                                                <ValidateRightLight />
                                            )}{" "}
                                            Minimum 8 Characters
                                        </li>
                                        <li>
                                            {/[^\w\s]/.test(values.password) ? (
                                                <ValidateRightDark />
                                            ) : (
                                                <ValidateRightLight />
                                            )}{" "}
                                            Special Characters
                                        </li>
                                        <li>
                                            {/[A-Z]/.test(values.password) ? (
                                                <ValidateRightDark />
                                            ) : (
                                                <ValidateRightLight />
                                            )}{" "}
                                            Uppercase Characters
                                        </li>
                                        <li>
                                            {typeof values.password !=
                                            "undefined" ? (
                                                /[a-z]/.test(
                                                    values?.password,
                                                ) ? (
                                                    <ValidateRightDark />
                                                ) : (
                                                    <ValidateRightLight />
                                                )
                                            ) : (
                                                <ValidateRightLight />
                                            )}{" "}
                                            Lowercase Characters
                                        </li>
                                        <li>
                                            {/[0-9]/.test(values.password) ? (
                                                <ValidateRightDark />
                                            ) : (
                                                <ValidateRightLight />
                                            )}{" "}
                                            Numeric Characters
                                        </li>
                                    </ul>
                                </div>
                            </UiCol>
                            <UiCol lg="12" className="sb-verify-mobile-no">
                                <UiMobileInput
                                    value={values.mobileNo}
                                    label="Mobile No"
                                    placeholder="Mobile Number"
                                    name="mobileNo"
                                />

                                <UiButton
                                    title="Send Verification OTP"
                                    style={
                                        errors.mobileNo
                                            ? { marginTop: 0 }
                                            : { marginTop: 15 }
                                    }
                                    className="sb-sign-up-mob-verify-btn"
                                    disabled={!errors.mobileNo ? false : true}
                                    onClick={() =>
                                        verifyMobileNo(values.mobileNo)
                                    }
                                />
                            </UiCol>
                            {true && (
                                <UiCol lg="12" className="sb-signup-otp">
                                    <p>
                                        The verification one-time pin for the
                                        mobile number entered has been sent.
                                        Please provide the one-time pin.
                                    </p>
                                    <div className="sb-otp-input-wr">
                                        <OtpInput
                                            value={values.otp}
                                            inputType="number"
                                            onChange={(value) => {
                                                form.mutators.setFormAttribute(
                                                    "otp",
                                                    value,
                                                );
                                            }}
                                            numInputs={6}
                                            maxLength={1}
                                            renderSeparator={<span> </span>}
                                            renderInput={(props) => (
                                                <input
                                                    {...props}
                                                    className="sb-otp-input"
                                                />
                                            )}
                                        />
                                        {form.getState().submitFailed &&
                                            errors.otp && (
                                                <span className="sb-otp-error">
                                                    {errors.otp}
                                                </span>
                                            )}
                                    </div>
                                </UiCol>
                            )}

                            {/* <UiCol lg="12">
                                    <UiInputLink
                                        text="Forgot your password?"
                                        link="/"
                                        align="right"
                                    />
                                </UiCol> */}

                            <UiCol lg="12" className="sb-checkbox-signup-wr">
                                <div className="sb-terms-checkbox-wr">
                                    <UiCheckboxInput
                                        label={`${"I've read and accepted the"}`}
                                        type="checkbox"
                                        for="terms"
                                        name="terms"
                                        id="terms"
                                        value={values.terms}
                                    />
                                    <div className="sb-terms-text">
                                        <span onClick={showTermsModal}>
                                            Rules & Terms of Use{" "}
                                        </span>
                                    </div>
                                </div>
                            </UiCol>
                            <UiCol lg="12">
                                <div className="sb-terms-checkbox-wr">
                                    <UiCheckboxInput
                                        label={`${"I've read and accepted the"}`}
                                        type="checkbox"
                                        for="policy"
                                        name="policy"
                                        id="policy"
                                        value={values.policy}
                                    />
                                    <div className="sb-terms-text">
                                        <span onClick={showPrivacyModal}>
                                            Privacy Policy{" "}
                                        </span>
                                    </div>
                                </div>
                            </UiCol>

                            <UiCol lg="12">
                                <UiButton
                                    // disabled={!policy || !terms}
                                    className="sb-main-primary-button sb-submit-button sb-renault-yellow-btn"
                                    title="Sign Up"
                                    onClick={handleSubmit}
                                />
                            </UiCol>
                            <UiCol lg="12">
                                <p className="sb-signup-bottom-text">
                                    Already have an account?
                                    <span onClick={() => navigate("/")}>
                                        Sign in
                                    </span>
                                </p>
                            </UiCol>
                        </form>
                    );
                }}
            />
        </>
    );
}
